export const validateNumberInput = (value: string, min = 0, max?: number) => {
  if (value === '') return '';
  if (isNaN(Number(value))) return '0';
  if (Number(value) < min) return min.toString();
  if (max !== undefined && Number(value) > max) return max.toString();
  return value;
};
